import { TGetMeResDto } from "@/types/dtos";
import { createSlice } from "@reduxjs/toolkit";

export type TAuthState = {
  isLoading?: boolean;
  accessToken: string;
  me: TGetMeResDto | null;
};

// statesx
const initialState: TAuthState = {
  accessToken: "",
  me: {
    userId: "",
    twitterUsername: "",
  },
};

// slice
const authSlice = createSlice({
  name: "AUTH",
  initialState,
  reducers: {
    setAccessToken(state, action) {
      state.accessToken = action.payload;
    },
    delAccessToken(state) {
      state.accessToken = initialState.accessToken;
    },
    logout(state) {
      state.accessToken = initialState.accessToken;
      state.me = initialState.me;
    },
    setMe(state, action) {
      state.me = action.payload;
    },
  },
});

export default authSlice.reducer;
export const authActions = authSlice.actions;
